/**
 * LA PORTÉE DES TAGS DE PAGE AGENT — `/agent`, et rien d'autre.
 *
 * Google Ads puis LinkedIn Insights ont demandé le même découpage : un tag
 * posé « sur la page /agent », sur un site qui n'a QU'UN document pour toutes
 * ses routes. Ce module est la liste blanche que les deux lisent — une seule
 * définition, pour que les deux composants ne puissent pas diverger sur ce
 * qui est « la page agent ».
 *
 * Liste BLANCHE en préfixe plutôt que noire en exclusion (patron
 * `MESSENGER_ROUTES` dans `IntercomProvider`) : une route publique ajoutée
 * demain n'hérite de rien, alors qu'une liste de pages à exclure aurait
 * laissé passer chaque nouveauté en silence.
 *
 * `/agents` est une redirection vers `/agent` (voir `App.tsx`) : le `/` du
 * préfixe est ce qui l'empêche de mordre.
 */
export function isAgentRoute(pathname: string): boolean {
  return pathname === '/agent' || pathname.startsWith('/agent/');
}
